// extracted by mini-css-extract-plugin
var _1 = "Y9KCY";
var _2 = "jGJ4l";
export { _1 as "hasError", _2 as "submit" }
